import clsx from 'clsx';
import { forwardRef, type ReactElement, type ReactNode, type Ref } from 'react';
import styles from './PressableText.module.scss';

interface SharedProps {
  children: ReactNode;
}

export interface PressableTextLinkProps extends SharedProps {
  href: string;
}

export interface PressableTextButtonProps extends SharedProps {
  href?: undefined;
}

type Props = PressableTextLinkProps | PressableTextButtonProps;

function Implementation(
  { children, ...props }: Props,
  ref: Ref<HTMLAnchorElement | HTMLButtonElement>,
) {
  const className = clsx(styles['text-button']);

  if (props.href) {
    return (
      <a
        ref={ref as Ref<HTMLAnchorElement>}
        className={className}
        href={props.href}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      ref={ref as Ref<HTMLButtonElement>}
      className={className}
      type="button"
    >
      {children}
    </button>
  );
}

const ForwardedPressableText = forwardRef(Implementation);

export const PressableText = ForwardedPressableText as {
  (props: PressableTextLinkProps & { ref?: Ref<HTMLAnchorElement> }): ReactElement;
  (props: PressableTextButtonProps & { ref?: Ref<HTMLButtonElement> }): ReactElement;
};
